module.exports = __webpack_public_path__ + "261e62278b6d508016e5098cc58b261f.png";